import { useState } from "react";

import useStrings from "../../useStrings";
import { ICodename } from "../../../commons/interfaces";
import { CommunityType } from "../../../constants/enums";

const useSelectData = () => {
    const Strings = useStrings();
    const [fontData, setFontData] = useState<ICodename[]>([
        {
            code: "Open Sans",
            name: "Open Sans",
        },
        {
            code: "Arial",
            name: "Arial",
        },
        {
            code: "Helvetica",
            name: "Helvetica",
        },
        {
            code: "sans-serif",
            name: "Sans-serif",
        },
    ]);

    const typeData = [
        {
            name: Strings.Common.Public,
            code: CommunityType.Public,
        },
        {
            name: Strings.Common.Private,
            code: CommunityType.Private,
        },
    ];

    return { fontData, typeData};
};

export default useSelectData;
